import { useLoaderData, useNavigate } from "react-router-dom";
import { getAllCollection } from "../../api/Get";
import Typography from "antd/es/typography";
import { Button, List } from "antd";
import CollectionCard from "./CollectionCard";

const { Title } = Typography;

const collectionsLoader = async () => {
  const details = await getAllCollection();
  return details;
};

const AllCollection = () => {
  const navigate = useNavigate();
  const { collections } = useLoaderData();

  const renderRow = (collection) => {
    return <CollectionCard collection={collection} />;
  };

  return (
    <>
      <Title level={2}>Collection</Title>
      <Button
        onClick={() => {
          navigate(`/collection/add`);
        }}
      >
        Ajouter une collection
      </Button>
      <br />
      <br />
      <List
        style={{ marginTop: 20 }}
        size="small"
        grid={{ column: 3 }}
        dataSource={collections}
        renderItem={renderRow}
      />
    </>
  );
};

export { AllCollection, collectionsLoader };
